import { useEffect, useRef } from "react";

const BrandCanvas = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas?.getContext("2d");
    if (!canvas || !context) return undefined;

    let width = 0;
    let height = 0;
    let circles = [];
    let resizeFrameId;
    const colors = ["#28c4ca", "#256bfe", "#087b85", "#13a876"];

    const createCircles = () => {
      const count = Math.min(
        24,
        Math.max(10, Math.round((width * height) / 90000)),
      );
      circles = Array.from({ length: count }, () => ({
        x: Math.random() * width,
        y: Math.random() * height,
        radius: 24 + Math.random() * 84,
        color: colors[Math.floor(Math.random() * colors.length)],
        alpha: 0.025 + Math.random() * 0.045,
      }));
    };

    const resize = () => {
      const parent = canvas.parentElement;
      width = parent.clientWidth;
      height = parent.clientHeight;
      // This is a soft-focus background, so rendering above CSS-pixel
      // resolution adds considerable fill cost without a visible benefit.
      const ratio = 1;
      canvas.width = Math.round(width * ratio);
      canvas.height = Math.round(height * ratio);
      canvas.style.width = `${width}px`;
      canvas.style.height = `${height}px`;
      context.setTransform(ratio, 0, 0, ratio, 0, 0);
      createCircles();
      drawFrame(0);
    };

    const scheduleResize = () => {
      cancelAnimationFrame(resizeFrameId);
      resizeFrameId = requestAnimationFrame(resize);
    };

    const drawFrame = () => {
      context.clearRect(0, 0, width, height);
      circles.forEach((circle) => {
        context.beginPath();
        context.arc(circle.x, circle.y, circle.radius, 0, Math.PI * 2);
        context.fillStyle = circle.color;
        context.globalAlpha = circle.alpha;
        context.fill();
      });
      context.globalAlpha = 1;
    };

    resize();
    window.addEventListener("resize", scheduleResize, { passive: true });
    return () => {
      cancelAnimationFrame(resizeFrameId);
      window.removeEventListener("resize", scheduleResize);
    };
  }, []);

  return <canvas className="brand-canvas" ref={canvasRef} aria-hidden="true" />;
};

export default BrandCanvas;
